import { render } from "./SendRateCard.vue?vue&type=template&id=06f62974&scoped=true"
import script from "./SendRateCard.vue?vue&type=script&lang=js"
export * from "./SendRateCard.vue?vue&type=script&lang=js"

import "./SendRateCard.vue?vue&type=style&index=0&id=06f62974&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f62974"]])

export default __exports__